﻿import { useNavigate } from "react-router-dom";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";
import { ReactComponent as ArchiveSvg } from "@/assets/images/desktop/archive.svg";
import { ReactComponent as ArchiveUpSvg } from "@/assets/images/desktop/archive-up.svg";

import { formatMilesDecimalNew, hasPermission } from "@/services/Utils";

import classes from "../../maintainers.module.scss";

const BusinessCenterTableDetail = ({ filter, item, handleDelete, permissions, handleArchive }) => {
	const navigate = useNavigate();

	if (!item.show) {
		return null;
	}

	return (
		<tr>
			<td colSpan={7} style={{ padding: "0.02rem 0.75rem 0.75rem 0.75rem" }}>
				<table className="table table-striped">
					<thead>
						<tr className="text-center">
							<th className={classes.th_detail}>Sector</th>
							<th className={classes.th_detail}>Especie</th>
							<th className={classes.th_detail}>Variedad</th>
							<th className={classes.th_detail}>Superficie (Ha)</th>
							<th className={classes.th_detail}></th>
						</tr>
					</thead>
					<tbody>
						{item &&
							item.business_centers &&
							item.business_centers.map((businessCenter, index) => {
								return (
									<tr className={`${classes.table_tr}`} key={index}>
										<td className={classes.table_td}>
											<div className={`${classes.table_div} ${classes.long_text} ${classes.center}`}>{businessCenter.name}</div>
										</td>
										<td className={classes.table_td}>
											<div className={`${classes.table_div} ${classes.long_text} ${classes.center}`}>{businessCenter.specie}</div>
										</td>
										<td className={classes.table_td}>
											<div className={`${classes.table_div} ${classes.long_text} ${classes.center}`}>{businessCenter.variety}</div>
										</td>
										<td className={classes.table_td}>
											<div className={`${classes.table_div} ${classes.long_text} ${classes.center}`}>
												{formatMilesDecimalNew(String(businessCenter.area).replace(".", ",")) ?? 0}
											</div>
										</td>
										<td className={classes.table_td}>
											<div className={`${classes.table_div} ${classes.long_text} ${classes.center}`}>
												{hasPermission("edit", permissions) && (
													<>
														{!!businessCenter.active && (
															<ArchiveSvg className={classes.icon} onClick={() => handleArchive(businessCenter)} />
														)}
													</>
												)}
												{filter.filter_type === "historico" && (
													<>
														{hasPermission("edit", permissions) && (
															<>
																{!item.active && (
																	<ArchiveUpSvg className={classes.icon} onClick={() => handleArchive(businessCenter)} />
																)}
															</>
														)}
													</>
												)}
												{hasPermission("edit", permissions) && (
													<PencilSvg
														className={classes.icon}
														onClick={() => navigate("/configuracion/centro_costo/editar/" + businessCenter.slug)}
													/>
												)}
												{hasPermission("delete", permissions) && (
													<RemoveSvg className={classes.icon} onClick={() => handleDelete(businessCenter, "child")} />
												)}
											</div>
										</td>
									</tr>
								);
							})}
					</tbody>
				</table>
			</td>
		</tr>
	);
};

export default BusinessCenterTableDetail;
